import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { PrimaryButton } from "./StyledButtons";
import qrypto_logo from ".././assets/images/logo/qrypto-official-logo.png";
import { StyledLinkGray } from "./StyledComponents";
import { Button, Menu, MenuItem, styled } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { KeyboardArrowDown } from "@mui/icons-material";
import vi8 from "../assets/images/flag/vi8.png";
import en8 from "../assets/images/flag/en8.png";
import { changeLanguage } from "../redux/language/reducer";
import i18n from "../i18n";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ModalContactGetTrialForm from "./ModalContactGetTrialForm";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Ngôn ngữ hiện tại luôn lấy theo prefix trên URL (/en hoặc /vi) - đây mới là nguồn
  // "đúng" duy nhất vì basename của BrowserRouter được xác định theo URL lúc App mount.
  const currentLang = window.location.pathname.startsWith("/vi")
    ? "vi"
    : "en";

  useEffect(() => {
    i18n.changeLanguage(currentLang);
    dispatch(changeLanguage(currentLang));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dispatch Redux language state để các phần khác của app (nếu đọc từ Redux) vẫn đồng bộ,
  // nhưng UI của Footer luôn hiển thị theo currentLang (đọc trực tiếp từ URL) ở trên.

  // Đổi ngôn ngữ = điều hướng sang URL với prefix /en hoặc /vi tương ứng (giữ nguyên phần
  // path/query/hash còn lại) rồi full reload, vì basename của BrowserRouter chỉ được xác
  // định 1 lần lúc App mount dựa theo URL.
  const handleLanguage = (nextLanguage, popupState) => {
    if (popupState) {
      popupState.close();
    }
    if (nextLanguage !== "en" && nextLanguage !== "vi") return;
    if (nextLanguage === currentLang) return;

    i18n.changeLanguage(nextLanguage);
    dispatch(changeLanguage(nextLanguage));

    const { pathname, search, hash } = window.location;
    const restPath = pathname.replace(/^\/(en|vi)/, "");
    const newPath = `/${nextLanguage}${restPath}`;

    window.location.href = `${newPath}${search}${hash}`;
  };

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setMousePosition({ x: e.nativeEvent.clientX, y: e.nativeEvent.clientY });
  };

  const StyleLanguageButton = styled(Button)(({ theme }) => ({
    padding: 0,
    color: "#fff",
    fontSize: "16px",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "transparent",
    },
  }));

  const MenuStyle = styled(Menu)(({ theme }) => ({
    "& .MuiList-root": {
      border: "1px solid #202641",
      backgroundColor: "#202641",
      boxShadow: "none",
      ".MuiMenuItem-root": {
        border: "1px solid #202641",
        color: "#FFF",
      },
    },
    "& .MuiPaper-root": {
      backgroundColor: "transparent",
    },
  }));

  const [modalGetTrialOpen, setModalGetTrialOpen] = useState(false);

  const modalGetTrialRef = useRef(null);

  const handleOverlayClick = (event) => {
    if (
      modalGetTrialRef.current &&
      !modalGetTrialRef.current.contains(event.target)
    ) {
      setModalGetTrialOpen(false);
    }
  };

  document.onkeydown = function (evt) {
    if (evt.code === "Escape") {
      setModalGetTrialOpen(false);
    }
  };

  return (
    <div className="footer container-fluid px-0 bg-primary">
      <div
        className="text-center bg-img-footer pt-100 pb-100 col-sm-12 px-0 why-wait"
        onMouseMove={handleMouseMove}
      >
        <div
          className="blur-white"
          style={{
            left: mousePosition.x - 500 + "px",
            top: mousePosition.y - 500 + "px",
          }}
        />
        <div className="index-10 col-sm-12">
          {currentLang === "en" ? (
            <p className="font-weight-semi-bold font-42 text-white pt-20">
              Why wait? It is easy to{" "}
              <span className="text-primary-orange">integrate Qrypto</span>
            </p>
          ) : (
            <p className="font-weight-semi-bold font-42 text-white pt-20">
              Đừng chờ đợi nữa.{" "}
              <span className="text-primary-orange">Tích hợp Qrypto</span> thật
              dễ dàng
            </p>
          )}
          <p className="font-weight-semi-bold font-42 text-white">
            {t("footer.take-the-first-step")}
          </p>
          <div className="pt-50">
            <PrimaryButton onClick={() => setModalGetTrialOpen(true)}>
              {t("button.get-a-free-trial")}
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="col-sm-12 pt-100 px-0">
          <div className="row">
            <div className="col-lg-3 col-md-12 text-md-center">
              <img
                src={qrypto_logo}
                alt="qrypto-logo"
                className="logo-img-footer"
              />
              <p className="text-gray pt-20" style={{ letterSpacing: 0 }}>
                {t("footer.introduce")}
              </p>
            </div>
            <div className="col-lg-9 col-md-12 pb-50 text-md-center">
              <div className="col-lg-3 col-md-6 col-sm-6 padding-md-30">
                <ul className="footer-list list-unstyled">
                  <li>
                    <p className="text-white font-20 pb-10">
                      {t("footer.technology")}
                    </p>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/technology/overview">
                      {t("footer.overview")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/technology/deployment">
                      {t("footer.deployment-options")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/technology/integration">
                      {t("footer.integration-options")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/technology/generating_pdf_reports_and_documents">
                      {t("footer.pdf-generation")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/technology/security">
                      {t("footer.security-privacy")}
                    </StyledLinkGray>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 padding-md-30">
                <ul className="footer-list list-unstyled">
                  <li>
                    <p className="text-white font-20 pb-10">
                      {t("footer.quick-links")}
                    </p>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/industries/general-and-hr">
                      {t("footer.general")}
                    </StyledLinkGray>
                  </li>
                  <li className="pr-md-20">
                    <StyledLinkGray component={Link} to="/industries/banking-and-financial">
                      {t("footer.banking-financial-services")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/industries/insurance">
                      {t("footer.insurance")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/industries/government">
                      {t("footer.government-regulators")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/industries/healthcare">
                      {t("footer.healthcare")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/industries/education">
                      {t("footer.educations")}
                    </StyledLinkGray>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 padding-md-30">
                <ul className="footer-list list-unstyled">
                  <li>
                    <p className="text-white font-20 pb-10">
                      {t("footer.company")}
                    </p>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/about-us">
                      {t("footer.about-us")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/contact">
                      {t("footer.contact-us")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/faq">
                      {t("footer.faq")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/case-study">
                      {t("footer.case-studies")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/whitepapers">
                      {t("footer.whitepapers")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray
                      component={Link}
                      to="/blog"
                      onClick={() => localStorage.removeItem("currentPage")}
                    >
                      {t("footer.blog")}
                    </StyledLinkGray>
                  </li>
                  <li>
                    <StyledLinkGray component={Link} to="/pricing">
                      {t("footer.pricing")}
                    </StyledLinkGray>
                  </li>
                </ul>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6 padding-md-30"
                style={{
                  paddingLeft: 0,
                  paddingRight: 0,
                }}
              >
                <ul className="footer-list list-unstyled">
                  <li>
                    <p className="text-white font-20 pb-10">
                      {t("footer.address")}
                    </p>
                  </li>
                  <li>
                    <p className="text-gray">{t("footer.address-content")}</p>
                  </li>
                  <li>
                    <p className="text-white font-20 pb-10 pt-10">
                      {t("footer.phone")}
                    </p>
                  </li>
                  <li>
                    <p className="text-gray">1900 6884</p>
                    <p className="text-gray">+84 28 3622 2982</p>
                  </li>
                  <li>
                    <p className="text-white font-20 pb-10 pt-10">Email</p>
                  </li>
                  <li>
                    <StyledLinkGray href="mailto:info@mobile-id.vn">
                      info@mobile-id.vn
                    </StyledLinkGray>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-12">
              <div
                className="back-to-top"
                onClick={() =>
                  window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
                }
              >
                <div className="flex">
                  <p className="mr-5">{t("footer.back-to-top")}</p>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                    >
                      <path
                        d="M5.6751 9.95005H4.4251V2.45005L0.987598 5.88755L0.100098 5.00005L5.0501 0.0500488L10.0001 5.00005L9.1126 5.88755L5.6751 2.45005V9.95005Z"
                        fill="#A4A6AE"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="border-b-gray"></div>
            </div>
            <div className="col-sm-12 pt-30 pb-30">
              <div className="col-lg-2 px-0 col-md-12 text-md-center">
                <PopupState variant="popover" popupId="popup-menu">
                  {(popupState) => (
                    <div>
                      <StyleLanguageButton
                        variant=""
                        {...bindTrigger(popupState)}
                      >
                        {currentLang === "en" ? (
                          <div className="flex justify-center align-center mt--2">
                            <img src={en8} alt="" className="mr-5 mt--2" />
                            <p>English</p>
                            <KeyboardArrowDown />
                          </div>
                        ) : (
                          <div className="flex justify-center align-center">
                            <img src={vi8} alt="" className="mr-5 mt--2" />
                            <p>Tiếng Việt</p>
                            <KeyboardArrowDown />
                          </div>
                        )}
                      </StyleLanguageButton>
                      <MenuStyle
                        {...bindMenu(popupState)}
                        disableScrollLock={true}
                        anchorOrigin={{
                          vertical: "top", // điểm neo ở phía trên của nút
                          horizontal: "left", // căn trái giống nút
                        }}
                        transformOrigin={{
                          vertical: "bottom", // menu sẽ mọc lên từ cạnh dưới của chính nó
                          horizontal: "left",
                        }}
                        // Optional: thêm margin để không dính sát nút
                        PaperProps={{
                          sx: {
                            mt: -1, // khoảng cách nhỏ lên trên
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            handleLanguage("en", popupState);
                          }}
                          style={{ fontSize: "12px" }}
                        >
                          <img
                            src={en8}
                            alt=""
                            style={{ width: "30px", marginRight: "10px" }}
                          />
                          English
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            handleLanguage("vi", popupState);
                          }}
                          style={{ fontSize: "12px", width: "150px" }}
                        >
                          <img
                            src={vi8}
                            alt=""
                            style={{ width: "30px", marginRight: "10px" }}
                          />
                          Tiếng Việt
                        </MenuItem>
                      </MenuStyle>
                    </div>
                  )}
                </PopupState>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="flex justify-center align-center">
                  <p className="text-gray">
                    Copyright © 2023 - {currentYear} Mobile-ID{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 px-0">
                <div className="flex justify-end gap-30 justify-md-center align-center">
                  <p>
                    <StyledLinkGray component={Link} to="/terms-of-service">
                      {t("footer.terms-of-service")}
                    </StyledLinkGray>
                  </p>
                  <p>
                    <StyledLinkGray component={Link} to="/privacy-policy">
                      {t("footer.privacy")}
                    </StyledLinkGray>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalGetTrialOpen && (
        <ModalContactGetTrialForm
          setOpenModal={setModalGetTrialOpen}
          handleOverlayClick={handleOverlayClick}
          modalRef={modalGetTrialRef}
        />
      )}
    </div>
  );
};

export default Footer;